import { runInAction } from 'mobx';
import React from 'react';
import MinutaDevolvidaApi from "../api/MinutaDevolvidaApi";
import NotificacaoMinutaDevolvida from '../components/NotificacaoMinutaDevolvida';
import { NotificacaoDto } from '../modelo/Notificacao';
import NotificacaoStore from "../store/NotificacaoStore";
import MenuAcessoRapidoStore from '../store/MenuAcessoRapidoStore';
import EscaninhoStore from '../store/EscaninhoStore';
import ProcessoStore from '../store/ProcessoStore';
import { SituacaoMinuta } from '../modelo/SituacaoMinuta';

class MinutaDevolvidaService {

    async verificarSeExistemMinutasDevolvidas() {
        // let count = await this.countMinutasDevolvidas();
        if (ProcessoStore.carregandoProcessosNoEscaninho) {
            setTimeout(() => {
                this.verificarSeExistemMinutasDevolvidas();
            }, 1000);
            return;
        }
        let count = 0;

        ProcessoStore._processos.forEach(processo => processo.minutas?.forEach(minuta => {
            if (minuta.situacaoMinuta.codigo === SituacaoMinuta.DEVOLVIDA_PARA_CORRECAO) {
                count++;
            }
        }))

        if (count) {
            runInAction(() => {
                NotificacaoStore.limpar('minutas-devolvidas');
                NotificacaoStore.notificacoes.push(
                    new NotificacaoDto("minutas-devolvidas", <NotificacaoMinutaDevolvida count={count} />)
                );
            });
        }
    }

    countMinutasDevolvidas() {
        return MinutaDevolvidaApi.countMinutasDevolvidas();
    }
}

export default new MinutaDevolvidaService();